/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Generic list
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CustomList extends Component {
    render() {
        const { data = [], renderItem } = this.props;
        return (
            <div className="container-fluid">
                {
                    data.map((item) => {
                        return (
                            <div
                                key={item.id}
                                onClick={() => { }}
                            >
                                {renderItem(item)}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

CustomList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.any.isRequired
    }))
};

export default CustomList;




// WEBPACK FOOTER //
// ./components/data-containers/list.js